<template>
  <div></div>
</template>

<script>
import crmService from '@/services/crmService'
export default {
  name: 'ResetPasswordVerify',
  created() {
    let query = window.location.search
    let start = query.indexOf('=') + 1
    let end = query.indexOf('&')
    crmService
      .resetPasswordVerify(this.$route.query.Email, query.slice(start, end))
      .then(res => {
        this.$message(res.data)
        this.$router.push('/logout')
      })
  },
}
</script>

<style scoped></style>
